module.exports = "<ui-view></ui-view>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/fanconsultores/components/app/template.html
// module id = 2698
// module chunks = 0